export function toLowerCase(type) {
    return type.toLowerCase();
}
